'use client'

// ---------------------------------------------------------------------------
// /library shell — the library as its own place at the workspace level.
//
// The library is one entity with three zoom levels: the in-project panel
// (use), the organize takeover (sort), and this page (manage & browse at full
// width — the surface a teammate opens with no project in mind). This layout
// only supplies the app breadcrumb and the viewport-height frame.
// ---------------------------------------------------------------------------

import type { ReactNode } from 'react'
import { useAppHeader } from '@/components/AppShell'
import { useLibraryUndo } from '@/components/collections/useLibraryUndo'

function LibraryBreadcrumb() {
  useAppHeader({ breadcrumbs: [{ label: 'Library' }] })
  return null
}

export default function LibraryLayout({ children }: { children: ReactNode }) {
  // CMD+Z / CMD+SHIFT+Z over the store's command seam, scoped to the library surface.
  const { undoToast } = useLibraryUndo()
  return (
    <div className="flex h-[calc(100vh-3rem)] flex-col bg-background text-foreground">
      <LibraryBreadcrumb />
      {children}
      {undoToast}
    </div>
  )
}
